import { z } from "zod";

/**
 * Upload Bot Profile Picture Schemas
 *
 * For uploading and optimizing bot profile pictures (Slack, Telegram, etc.)
 * Creates multiple size variants and uploads to S3.
 */

// Path variables
export const UploadBotProfilePicturePathVarsSchema = z.object({
  id: z.string().uuid()
});

// Response data (unwrapped - ApiSuccessSchema applied automatically)
export const UploadBotProfilePictureResponseSchema = z.object({
  success: z.boolean(),
  original: z.string(),
  sizes: z.record(z.string(), z.string()),
  default: z.string()
});

// Type exports
export type UploadBotProfilePicturePathVars = z.infer<typeof UploadBotProfilePicturePathVarsSchema>;
export type UploadBotProfilePictureResponse = z.infer<typeof UploadBotProfilePictureResponseSchema>;
